import React, { useState } from "react"
import { Box, Heading, Text } from "@chakra-ui/react"
import { StaticImage } from "gatsby-plugin-image"
// import { navigate } from "gatsby"

import ResponsivePlayer from "../../components/minPlayer/minPlayer"
import centerVideo from "../../assets/centerVideo.mp4"

export function CompanyBox({ children, nav }) {
  // const [click, setClick] = useState(false)

  return (
    <Box
      cursor="default"
      position="relative"
      // _active={{ boxShadow: "5px 5px 5px #ccc" }}
      // onclick event
      // onClick={() => {
      //   setClick(true)
      //   navigate(nav)
      //   setInterval(() => setClick(false), 150)
      // }}
    >
      {children}
      <Box
        // display={click === true ? "inline" : "none"}
        display="none"
        position="absolute"
        w="20%"
        left="40%"
        bottom="0.5rem"
        borderBottom="2px solid #000"
        zIndex="100"
      ></Box>
    </Box>
  )
}

const Portfolios = () => {
  // const theme = useTheme();
  // const matches = false;
  // const theme = useTheme();
  // const [matches] = useMediaQuery(theme.breakpoints.up('sm'));
  const matches = true
  // const [isLargerThan600] = useMediaQuery("(min-width: 600px)");
  // const isLargerThan960 = useMediaQuery("(min-width: 960px)");

  //  console.log(isLargerThan600)

  return (
    <Box maxW="1210px" mx={8}>
      {/* title  */}
      <section id="Portfolio">
        <Heading
          pt={7}
          color="#333"
          fontSize={{ base: "xl", md: "2xl" }}
          borderBottom="4px solid #E2E8F0"
        >
          <Box as="span" borderBottom="4px solid #2B6CB0">
            News
          </Box>
          &nbsp; & Events
        </Heading>
      </section>

   
      <br />
      <br />

      {/* <StaticImage
        src="../../images/flyer.jpeg"
        alt="A dinosaur"
        placeholder="blurred"
        // layout="fixed"
      /> */}

     <Box />
     {/* <Box mt="4rem" /> */}
       {/* first row  */}
      {/* pc */}
      <Box
        maxW="1100px"
        margin="0 auto"
        padding="0 auto"
        // h={{md:'36rem'}}
        display={{base: "none",sm: "none",md: "flex"}}
        >
        <ResponsivePlayer isPhone={false} url={centerVideo} controls={false} playing={true} isCenterVideo={true}/>
      </Box>
      {/* phone */}
      <Box
        maxW="1100px"
        margin="0 auto"
        padding="0 auto"
        // h={{sm:'20rem'}}
        display={{base: "flex",sm:"flex", md: "none"}}
        >
        <ResponsivePlayer isPhone={true} url={centerVideo} controls={true} playing={false} isCenterVideo={true}/>
      </Box>    

      {/* <br /> */}
      <br />
      <br />
      <Heading fontSize="2rem" textAlign="center">
        Dream Space：New Wave in the Metaverse NFT Art Exhibition
      </Heading>
      <br />
      <Text textAlign="center"> MIAM × The Parisian Macao</Text>
      <br />
      <Text textAlign="center">
      Team up with renowned NFT artists worldwide,
      </Text>
      <br />
      <Text textAlign="center">
      presenting a new dimension of technology and art.
      </Text>
      <br />

      <Text textAlign="center">
        {/* <div style={{display:'inline-block' ,textAlign:'left'}}><strong>Date:&nbsp;<br />&nbsp;</strong></div> */}
        {/* <div style={{display:'inline-block' ,textAlign:'left'}}>2022.04.30. VIP Vernissage<br />2022.05.01-06.12  Open to Public</div> */}
        <strong>Date: </strong> 
        2022.09.08-2023.05.30  Open to Public

      </Text>
      {/* <Text textAlign="center">
        <strong>Date：</strong>2022.04.30. VIP Vernissage
        <div>
        &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          2022.05.01-05.31 Open to Public
        </div>
      </Text> */}
      <br />
      <Text textAlign="center">
        <strong>Venue: </strong> Shop 549, Level 5, Shoppes at Parisian, Macau
      </Text>
    </Box>
  )
}

export default Portfolios
